/* Blank products need an explicit acknowledgment before add to cart or checkout.
   The sentence is not shown on the page. It opens as a popup when Add to cart
   is clicked with no artwork, and again at checkout only if that line was
   never acknowledged. Decorated lines, print goods, banners, signs, and
   flags skip it. The sentence is stored as the line property
   "Blank acknowledgment" and, at cart checkout, as a cart attribute
   with the same name. */
(function () {
  var ACK_TEXT = "I understand I am purchasing blank products with no printing or decoration. Returns of unworn, unwashed blank items within 30 days are subject to a 20% restocking fee. Decorated items are non-returnable unless defective.";
  var CLOSEOUT_ACK_TEXT = "I understand I am purchasing closeout blank products with no printing or decoration. Closeout blanks are final sale.";
  var MIXED_ACK_TEXT = "I understand I am purchasing blank products with no printing or decoration. Returns of unworn, unwashed blank items within 30 days are subject to a 20% restocking fee. Closeout sizes are final sale. Decorated items are non-returnable unless defective.";
  var ACK_KEY = "Blank acknowledgment";
  var CLOSEOUT_KEY = "_closeout";
  var ACK_MSG = "Check the box to continue.";
  var SKIP_TYPES = { Print: 1, Signs: 1, Canopy: 1, Decoration: 1, "Gift Card": 1 };
  var SKIP_TAGS = {
    print: 1,
    "print-catalog": 1,
    "banners-signs": 1,
    banner: 1,
    flag: 1,
    sign: 1,
    canopy: 1
  };
  var DECO_KEYS = {
    Print: 1,
    Decoration: 1,
    "_Artwork locations": 1,
    "Artwork locations": 1,
    _deco_each: 1
  };
  var DRAWER_SEL = "#CartDrawer, cart-drawer, .cart-drawer, #mini-cart, .mini-cart, .mini-cart-wrap, .cart-flyout, [data-cart-drawer], .ajaxcart, #ajaxCart, .cart-popup, .drawer--cart";
  var EXPRESS_SEL = ".shopify-payment-button, .additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .dynamic-checkout__content";

  function propsOf(item) {
    var src = item && item.properties;
    var out = {};
    if (!src) return out;
    if (Array.isArray(src)) {
      src.forEach(function (row) {
        if (Array.isArray(row) && row.length >= 2) out[String(row[0])] = row[1];
        else if (row && row.name) out[String(row.name)] = row.value;
      });
      return out;
    }
    if (typeof src === "object") {
      Object.keys(src).forEach(function (key) { out[key] = src[key]; });
    }
    return out;
  }

  function tagsOf(item) {
    var tags = item && (item.tags || item.product_tags);
    if (!tags) return [];
    if (typeof tags === "string") tags = tags.split(",");
    if (!Array.isArray(tags)) return [];
    return tags.map(function (tag) { return String(tag).trim().toLowerCase(); }).filter(Boolean);
  }

  function isDecorationItem(item) {
    if (!item) return false;
    var props = propsOf(item);
    if (props._print_adjust || props["_print_adjust"]) return true;
    var handle = String(item.handle || item.product_handle || "");
    if (handle === "ezink-htv-decoration" || handle === "print-spec-adjustment") return true;
    var type = String(item.product_type || item.productType || "");
    if (type === "Decoration") return true;
    var title = String(item.product_title || item.title || "");
    if (title === "Specification difference") return true;
    var tags = tagsOf(item);
    if (tags.indexOf("htv-addon") >= 0 || tags.indexOf("print-adjust") >= 0) return true;
    return false;
  }

  function isSkippedProduct(item) {
    if (!item || item.gift_card) return true;
    var type = String(item.product_type || item.productType || "");
    if (type === "Gift Card" || type === "Decoration") return true;
    var tags = tagsOf(item);
    if (tags.indexOf("blanks") >= 0) return false;
    if (SKIP_TYPES[type]) return true;
    for (var i = 0; i < tags.length; i++) {
      if (SKIP_TAGS[tags[i]]) return true;
    }
    return false;
  }

  function hasDecorationProps(props) {
    var keys = Object.keys(props || {});
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var value = props[key];
      if (value == null || String(value).trim() === "") continue;
      if (DECO_KEYS[key]) return true;
      if (key.indexOf("Print | ") >= 0 || key.indexOf("_Print | ") === 0) return true;
      if (key.indexOf("_artwork_") === 0 || key.indexOf("artwork_") === 0) return true;
      if (key.indexOf("Print size ") === 0 || key.indexOf("Print type ") === 0) return true;
    }
    return false;
  }

  function itemNeedsBlankAck(item, items) {
    if (!item || isDecorationItem(item) || isSkippedProduct(item)) return false;
    var props = propsOf(item);
    if (hasDecorationProps(props)) return false;
    var setId = String(props["_Artwork set"] || "");
    if (setId && items && items.length) {
      for (var i = 0; i < items.length; i++) {
        var other = items[i];
        if (!other || other === item) continue;
        if (String(propsOf(other)["_Artwork set"] || "") !== setId) continue;
        if (isDecorationItem(other)) return false;
      }
    }
    return true;
  }

  function cartNeedsBlankAck(items) {
    items = items || [];
    for (var i = 0; i < items.length; i++) {
      if (itemNeedsBlankAck(items[i], items)) return true;
    }
    return false;
  }

  function isCloseoutLine(item) {
    return String(propsOf(item)[CLOSEOUT_KEY] || "") === "1";
  }

  function itemNeedsBlankPrompt(item, items) {
    if (!itemNeedsBlankAck(item, items)) return false;
    var got = String(propsOf(item)[ACK_KEY] || "");
    if (isCloseoutLine(item)) return got !== CLOSEOUT_ACK_TEXT;
    return got !== ACK_TEXT && got !== CLOSEOUT_ACK_TEXT;
  }

  function blankPurchaseKind(form) {
    var root = sectionNear(form) || (form && form.closest && form.closest("[data-section-type='product']")) || form;
    var productCloseout = !!(root && root.getAttribute && root.getAttribute("data-ezink-closeout") === "1");
    var inputs = root && root.querySelectorAll ? root.querySelectorAll("[data-ezink-size-qty-input]") : [];
    var selected = 0;
    var closeout = 0;
    Array.prototype.forEach.call(inputs, function (inp) {
      if (!inp || inp.disabled) return;
      var n = parseInt(inp.value, 10) || 0;
      if (n < 1) return;
      selected += 1;
      if (productCloseout || inp.getAttribute("data-ezink-closeout") === "1") closeout += 1;
    });
    if (!selected) {
      return {
        allCloseout: productCloseout,
        anyCloseout: productCloseout,
        text: productCloseout ? CLOSEOUT_ACK_TEXT : ACK_TEXT
      };
    }
    var allCloseout = closeout === selected;
    var anyCloseout = closeout > 0;
    var text = ACK_TEXT;
    if (allCloseout) text = CLOSEOUT_ACK_TEXT;
    else if (anyCloseout) text = MIXED_ACK_TEXT;
    return { allCloseout: allCloseout, anyCloseout: anyCloseout, text: text };
  }

  function checkoutPromptText(items) {
    var closeout = false;
    var regular = false;
    (items || []).forEach(function (item) {
      if (!itemNeedsBlankPrompt(item, items)) return;
      if (isCloseoutLine(item)) closeout = true;
      else regular = true;
    });
    if (closeout && regular) return MIXED_ACK_TEXT;
    if (closeout) return CLOSEOUT_ACK_TEXT;
    return ACK_TEXT;
  }

  function checkoutPromptTextFromRows(rows) {
    var closeout = false;
    var regular = false;
    (rows || []).forEach(function (row) {
      if (!row || !row.needs) return;
      if (row.closeout) closeout = true;
      else regular = true;
    });
    if (closeout && regular) return MIXED_ACK_TEXT;
    if (closeout) return CLOSEOUT_ACK_TEXT;
    return ACK_TEXT;
  }

  function editorCoversItem(item, editor) {
    if (!item || !editor) return false;
    var key = String(item.key || "");
    if (key && editor.keys && editor.keys[key]) return true;
    var setId = String(propsOf(item)["_Artwork set"] || "");
    if (setId && editor.sets && editor.sets[setId]) return true;
    return false;
  }

  function itemsNeedAck(items, editor) {
    items = items || [];
    for (var i = 0; i < items.length; i++) {
      if (!itemNeedsBlankAck(items[i], items)) continue;
      if (editorCoversItem(items[i], editor)) continue;
      return true;
    }
    return false;
  }

  function rowsNeedBlankAck(rows, editor) {
    rows = rows || [];
    editor = editor || {};
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!row || !row.needs) continue;
      if (row.key && editor.keys && editor.keys[row.key]) continue;
      if (row.set && editor.sets && editor.sets[row.set]) continue;
      return true;
    }
    return false;
  }

  // A location is a row the customer added. A leftover decoration string, print mode,
  // or a file that was cleared with the row does not keep the blank checkbox hidden.
  function rootHasArtworkLocation(root) {
    if (!root || typeof root.querySelector !== "function") return false;
    return !!root.querySelector("[data-ezink-art-item]");
  }

  function matchesSel(el, sel) {
    return !!(el && el.matches && el.matches(sel));
  }

  function isArtPdp(el) {
    return !!(el && el.getAttribute && el.getAttribute("data-ezink-art-pdp") != null);
  }

  function sectionNear(node) {
    if (!node) return null;
    if (node.closest) {
      var via = node.closest("[id^='ProductSection-']");
      if (via) return via;
    }
    if (matchesSel(node, "[id^='ProductSection-']")) return node;
    var cursor = node;
    while (cursor) {
      var prev = cursor.previousElementSibling;
      while (prev) {
        if (matchesSel(prev, "[id^='ProductSection-']")) return prev;
        prev = prev.previousElementSibling;
      }
      cursor = cursor.parentElement;
    }
    return null;
  }

  // ProductSection's closing div sits before .ezink-pdp-art. The HTML parser
  // ends the product form there, so the location rows and the sticky checkbox
  // are outside the form. Walk the siblings that follow the section.
  function artworkHostsAfter(section) {
    var hosts = [];
    if (!section) return hosts;
    var sib = section.nextElementSibling;
    var guard = 0;
    while (sib && guard < 8) {
      guard += 1;
      if (matchesSel(sib, "[id^='ProductSection-']") || matchesSel(sib, ".shopify-section") || matchesSel(sib, ".ezink-pdp-info")) break;
      hosts.push(sib);
      if (sib.classList && (sib.classList.contains("ezink-pdp-atc") || sib.classList.contains("ezink-pdp-info"))) break;
      sib = sib.nextElementSibling;
    }
    return hosts;
  }

  function isProductAckBox(box) {
    if (!box || !box.getAttribute) return false;
    if (box.getAttribute("data-ezink-blank-ack-context") === "cart") return false;
    if (box.hasAttribute) return box.hasAttribute("data-ezink-blank-ack");
    return box.getAttribute("data-ezink-blank-ack") != null;
  }

  function boxesInNode(scope) {
    if (!scope || typeof scope.querySelectorAll !== "function") return [];
    return Array.prototype.filter.call(scope.querySelectorAll("[data-ezink-blank-ack]"), isProductAckBox);
  }

  function productAckBoxes(artRoot) {
    var boxes = [];
    function addFrom(scope) {
      boxesInNode(scope).forEach(function (box) {
        if (boxes.indexOf(box) < 0) boxes.push(box);
      });
    }
    var section = sectionNear(artRoot);
    addFrom(section);
    artworkHostsAfter(section).forEach(addFrom);
    var host = artRoot && artRoot.closest ? (artRoot.closest(".ezink-pdp-art") || artRoot) : artRoot;
    addFrom(host);
    if (host && host.nextElementSibling) addFrom(host.nextElementSibling);
    return boxes;
  }

  function productHasArtworkLocation(artRoot) {
    var pdp = artRoot;
    if (artRoot && !isArtPdp(artRoot)) {
      var inner = artRoot.closest && artRoot.closest("[data-ezink-art-pdp]");
      if (inner) pdp = inner;
      else if (artRoot.querySelector) {
        var found = artRoot.querySelector("[data-ezink-art-pdp]");
        if (found) pdp = found;
      }
    }
    if (rootHasArtworkLocation(pdp)) return true;
    var section = sectionNear(pdp || artRoot);
    var hosts = artworkHostsAfter(section);
    for (var i = 0; i < hosts.length; i++) {
      if (rootHasArtworkLocation(hosts[i])) return true;
    }
    return false;
  }

  // show/checked are the cart checkbox. clearAttribute removes the saved cart acknowledgment.
  function cartAckView(prev, needs) {
    var shown = !!(prev && prev.show);
    var checked = !!(prev && prev.checked);
    if (!needs) return { show: false, checked: false, clearAttribute: true };
    if (!shown) return { show: true, checked: false, clearAttribute: false };
    return { show: true, checked: checked, clearAttribute: false };
  }

  // Properties to send with /cart/change.js after decoration removes the acknowledgment.
  // Other keys are kept. An empty result still sends the acknowledgment as "" so Shopify drops it.
  function replacementProperties(props) {
    var out = {};
    var keys = Object.keys(props || {});
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (key === ACK_KEY || key === CLOSEOUT_KEY) continue;
      var value = props[key];
      if (value == null || value === "") continue;
      if (typeof value === "string" || typeof value === "number") out[key] = String(value);
      else if (value && value.url) out[key] = String(value.url);
      else return null;
    }
    if (!Object.keys(out).length) out[ACK_KEY] = "";
    return out;
  }

  var api = {
    ACK_TEXT: ACK_TEXT,
    CLOSEOUT_ACK_TEXT: CLOSEOUT_ACK_TEXT,
    MIXED_ACK_TEXT: MIXED_ACK_TEXT,
    ACK_KEY: ACK_KEY,
    CLOSEOUT_KEY: CLOSEOUT_KEY,
    ACK_MSG: ACK_MSG,
    propsOf: propsOf,
    isDecorationItem: isDecorationItem,
    isSkippedProduct: isSkippedProduct,
    hasDecorationProps: hasDecorationProps,
    itemNeedsBlankAck: itemNeedsBlankAck,
    itemNeedsBlankPrompt: itemNeedsBlankPrompt,
    blankPurchaseKind: blankPurchaseKind,
    checkoutPromptText: checkoutPromptText,
    cartNeedsBlankAck: cartNeedsBlankAck,
    editorCoversItem: editorCoversItem,
    itemsNeedAck: itemsNeedAck,
    rowsNeedBlankAck: rowsNeedBlankAck,
    cartAckView: cartAckView,
    replacementProperties: replacementProperties,
    rootHasArtworkLocation: rootHasArtworkLocation,
    productHasArtworkLocation: productHasArtworkLocation,
    productAckBoxes: productAckBoxes
  };

  if (typeof module !== "undefined" && module.exports) module.exports = api;
  if (typeof window !== "undefined") window.EZINKBlankAck = api;
  if (typeof document === "undefined") return;

  function jsonRows() {
    var node = document.querySelector("[data-ezink-blank-cart]");
    if (!node) return null;
    try { return JSON.parse(node.textContent || "[]"); } catch (err) { return []; }
  }

  function jsonNeeds() {
    var rows = jsonRows();
    if (!rows) return null;
    return rows.some(function (row) { return row && row.needs; });
  }

  function formOf(el) {
    if (!el) return null;
    return (el.closest && (el.closest("form") || el.closest("[data-product-form]"))) || null;
  }

  function boxesIn(scope) {
    if (!scope || !scope.querySelectorAll) return [];
    return Array.prototype.slice.call(scope.querySelectorAll("[data-ezink-blank-ack]"));
  }

  function boxVisible(box) {
    if (!box || box.hidden) return false;
    var popup = box.closest && box.closest("[data-cart-popup-wrapper]");
    if (popup && popup.classList.contains("cart-popup-wrapper--hidden")) return false;
    if (window.getComputedStyle(box).display === "none") return false;
    return true;
  }

  function anyChecked(boxes) {
    for (var i = 0; i < boxes.length; i++) {
      var input = boxes[i].querySelector("[data-ezink-blank-ack-input]");
      if (input && input.checked) return true;
    }
    return false;
  }

  // The checkbox stays in the page so the line property can be posted, but CSS
  // hides it. Do not treat display:none as "not accepted."
  function ackBoxLive(box) {
    if (!box || box.hidden) return false;
    if (box.getAttribute && box.getAttribute("data-ezink-blank-ack-context") === "cart") return false;
    if (box.classList && box.classList.contains("ezink-blank-ack--off")) return false;
    return true;
  }

  function syncProp(form) {
    if (!form) return;
    var prop = form.querySelector("[data-ezink-blank-ack-prop]");
    if (!prop) return;
    var boxes = boxesIn(form).filter(ackBoxLive);
    if (boxes.length && anyChecked(boxes)) {
      prop.disabled = false;
      prop.value = ACK_TEXT;
    } else {
      prop.disabled = true;
      prop.value = "";
    }
  }

  function showMessage(scope) {
    var root = formOf(scope) || (scope && scope.closest && scope.closest("[data-ezink-blank-ack]")) || document;
    var boxes = boxesIn(root).filter(boxVisible);
    if (!boxes.length && scope && scope.closest) {
      var own = scope.closest("[data-ezink-blank-ack]");
      if (own) boxes = [own];
    }
    boxes.forEach(function (box) {
      box.hidden = false;
      var msg = box.querySelector("[data-ezink-blank-ack-msg]");
      if (msg) {
        msg.hidden = false;
        msg.textContent = ACK_MSG;
      }
      var input = box.querySelector("[data-ezink-blank-ack-input]");
      if (input) input.setAttribute("aria-invalid", "true");
    });
    var focusBox = boxes[0];
    var focusInput = focusBox && focusBox.querySelector("[data-ezink-blank-ack-input]");
    if (focusInput && focusInput.focus) focusInput.focus();
  }

  function clearMessage(boxes) {
    (boxes || []).forEach(function (box) {
      var msg = box.querySelector("[data-ezink-blank-ack-msg]");
      if (msg) msg.hidden = true;
      var input = box.querySelector("[data-ezink-blank-ack-input]");
      if (input) input.removeAttribute("aria-invalid");
    });
  }

  function choiceMeansDecoration(value) {
    var text = String(value || "").trim();
    return !!text && text.toLowerCase() !== "blank";
  }

  function fileChosen(scope) {
    if (!scope || !scope.querySelectorAll) return false;
    return Array.prototype.some.call(scope.querySelectorAll("[data-ezink-file]"), function (input) {
      return input.files && input.files.length;
    });
  }

  function scopeHasDecoration(scope) {
    if (!scope || !scope.querySelector) return false;
    if (scope.getAttribute && scope.getAttribute("data-ezink-art-mode") === "print") return true;
    var pdp = scope.querySelector("[data-ezink-art-pdp]");
    if (pdp) {
      if (pdp.getAttribute("data-ezink-art-mode") === "print") return true;
      if (pdp.querySelector("[data-ezink-art-item]")) return true;
      if (fileChosen(pdp)) return true;
    }
    if (scope.querySelector("[data-ezink-art-item]")) return true;
    if (fileChosen(scope)) return true;
    var promo = scope.querySelector("[data-ezink-promo-deco]");
    if (promo && choiceMeansDecoration(promo.value)) return true;
    var types = scope.querySelectorAll("[name='properties[Decoration type]']");
    for (var i = 0; i < types.length; i++) {
      if (choiceMeansDecoration(types[i].value)) return true;
    }
    var imprint = scope.querySelector("[data-ezink-promo-method], [data-ezink-promo-loc]");
    if (imprint && !imprint.disabled && choiceMeansDecoration(imprint.value)) return true;
    return false;
  }

  function formHasDecoration(form) {
    return productHasArtworkLocation(form);
  }

  function uncheckBox(box) {
    if (!box) return;
    var input = box.querySelector("[data-ezink-blank-ack-input]");
    if (input) input.checked = false;
    var msg = box.querySelector("[data-ezink-blank-ack-msg]");
    if (msg) msg.hidden = true;
    if (input) input.removeAttribute("aria-invalid");
  }

  function refreshProductForm(form) {
    if (!form) return;
    var boxes = boxesIn(form).filter(function (box) {
      return box.getAttribute("data-ezink-blank-ack-context") !== "cart";
    });
    if (!boxes.length) return;
    var decorated = formHasDecoration(form);
    boxes.forEach(function (box) {
      if (decorated) {
        uncheckBox(box);
        box.hidden = true;
        if (box.classList) box.classList.add("ezink-blank-ack--off");
      } else {
        var wasHidden = box.hidden || (box.classList && box.classList.contains("ezink-blank-ack--off"));
        if (box.classList) box.classList.remove("ezink-blank-ack--off");
        if (box.style && box.style.removeProperty) box.style.removeProperty("display");
        box.hidden = false;
        if (wasHidden) uncheckBox(box);
      }
    });
    if (decorated) clearMessage(boxes);
    syncProp(form);
    syncExpress(form, !decorated && !anyChecked(boxes.filter(ackBoxLive)));
  }

  function cartBoxes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ezink-blank-ack][data-ezink-blank-ack-context="cart"]'));
  }

  function setCartBoxes(show) {
    cartBoxes().forEach(function (box) {
      box.hidden = !show;
      if (!show) {
        var msg = box.querySelector("[data-ezink-blank-ack-msg]");
        if (msg) msg.hidden = true;
      }
    });
    document.querySelectorAll("[data-ezink-blank-ack-cart]").forEach(function (form) {
      if (show) form.setAttribute("data-ezink-blank-required", "1");
      else form.removeAttribute("data-ezink-blank-required");
    });
    forCartExpress(show && !cartChecked());
  }

  function cartChecked() {
    return anyChecked(cartBoxes().filter(boxVisible));
  }

  function forCartExpress(block) {
    document.querySelectorAll("[data-ezink-blank-ack-cart], " + DRAWER_SEL).forEach(function (scope) {
      syncExpress(scope, block);
    });
  }

  function shieldHost(host) {
    if (!host) return;
    var existing = host.querySelector(".ezink-blank-ack-shield");
    if (existing) {
      existing.hidden = false;
      return;
    }
    if (window.getComputedStyle(host).position === "static") host.style.position = "relative";
    var shield = document.createElement("button");
    shield.type = "button";
    shield.className = "ezink-blank-ack-shield";
    shield.setAttribute("aria-label", ACK_MSG);
    shield.addEventListener("click", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
      var cartish = host.closest(DRAWER_SEL + ", [data-ezink-blank-ack-cart], form.cart");
      if (cartish) {
        askThenCheckout(host, checkoutPromptTextFromRows(jsonRows()));
        return;
      }
      productBlocked(host);
    });
    host.appendChild(shield);
  }

  function unshield(host) {
    if (!host) return;
    var shield = host.querySelector(".ezink-blank-ack-shield");
    if (shield) shield.hidden = true;
  }

  function nearestBox(el) {
    var root = (el && el.closest && (el.closest("[data-ezink-blank-ack-cart]") || el.closest("form") || el.closest(DRAWER_SEL))) || document;
    var boxes = boxesIn(root);
    for (var i = 0; i < boxes.length; i++) if (!boxes[i].hidden) return boxes[i];
    return boxes[0] || null;
  }

  function syncExpress(scope, block) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll(EXPRESS_SEL).forEach(function (host) {
      if (block) shieldHost(host);
      else unshield(host);
    });
  }

  function ensureCartBox(near) {
    var root = (near && near.closest && (near.closest("[data-ezink-blank-ack-cart]") || near.closest(DRAWER_SEL) || near.closest("form"))) || document.body;
    var box = root.querySelector('[data-ezink-blank-ack][data-ezink-blank-ack-context="cart"]');
    if (box) {
      box.hidden = false;
      return box;
    }
    box = document.createElement("div");
    box.className = "ezink-blank-ack ezink-blank-ack--cart";
    box.setAttribute("data-ezink-blank-ack", "");
    box.setAttribute("data-ezink-blank-ack-context", "cart");
    box.innerHTML = '<label class="ezink-blank-ack__label"><input type="checkbox" data-ezink-blank-ack-input><span>' + ACK_TEXT + '</span></label><p class="ezink-blank-ack__msg" data-ezink-blank-ack-msg role="alert" hidden>' + ACK_MSG + '</p>';
    if (near && near.parentNode) near.parentNode.insertBefore(box, near);
    else root.insertBefore(box, root.firstChild);
    return box;
  }

  function productFormOf(el) {
    var form = formOf(el);
    if (form && form.querySelector && form.querySelector("[data-ezink-blank-ack-prop]")) return form;
    var section = sectionNear(el);
    if (section && section.querySelector) {
      var inner = section.querySelector("form[action*='/cart/add'], form.product-form, [data-product-form]");
      if (inner) return inner;
    }
    return form;
  }

  var popWait = null;
  var popPromise = null;

  function ensureBlankPop() {
    var dlg = document.querySelector("[data-ezink-blank-pop]");
    if (dlg) return dlg;
    dlg = document.createElement("div");
    dlg.className = "ezink-blank-pop";
    dlg.setAttribute("data-ezink-blank-pop", "");
    dlg.hidden = true;
    dlg.innerHTML = '<div class="ezink-blank-pop__backdrop" data-ezink-blank-pop-cancel></div>' +
      '<div class="ezink-blank-pop__dialog" role="dialog" aria-modal="true" aria-labelledby="ezink-blank-pop-text">' +
      '<p class="ezink-blank-pop__text" id="ezink-blank-pop-text"></p>' +
      '<div class="ezink-blank-pop__actions">' +
      '<button type="button" class="ezink-blank-pop__cancel" data-ezink-blank-pop-cancel>Cancel</button>' +
      '<button type="button" class="ezink-blank-pop__ok" data-ezink-blank-pop-ok>Add to cart</button>' +
      '</div></div>';
    dlg.querySelector(".ezink-blank-pop__text").textContent = ACK_TEXT;
    document.body.appendChild(dlg);
    return dlg;
  }

  function closeBlankPop(accepted) {
    var dlg = document.querySelector("[data-ezink-blank-pop]");
    if (dlg) dlg.hidden = true;
    document.body.style.overflow = "";
    var resolve = popWait;
    popWait = null;
    popPromise = null;
    if (resolve) resolve(!!accepted);
  }

  function openBlankPop(opts) {
    if (popPromise) return popPromise;
    opts = opts || {};
    var dlg = ensureBlankPop();
    var ok = dlg.querySelector("[data-ezink-blank-pop-ok]");
    if (ok) ok.textContent = opts.okLabel || "Add to cart";
    var textEl = dlg.querySelector(".ezink-blank-pop__text");
    if (textEl) textEl.textContent = opts.text || ACK_TEXT;
    dlg.hidden = false;
    document.body.style.overflow = "hidden";
    if (ok && ok.focus) ok.focus();
    popPromise = new Promise(function (resolve) { popWait = resolve; });
    return popPromise;
  }

  function markProductAccepted(form, kind) {
    if (!form) return;
    boxesIn(form).forEach(function (box) {
      if (box.getAttribute("data-ezink-blank-ack-context") === "cart") return;
      var input = box.querySelector("[data-ezink-blank-ack-input]");
      if (input) input.checked = true;
    });
    var prop = form.querySelector("[data-ezink-blank-ack-prop]");
    if (prop) {
      prop.disabled = false;
      prop.value = kind && kind.allCloseout ? CLOSEOUT_ACK_TEXT : ACK_TEXT;
    }
    syncExpress(form, false);
  }

  function resumeBuy(el) {
    pass(el);
    if (el && el.tagName === "FORM") {
      if (el.requestSubmit) el.requestSubmit();
      else if (el.submit) el.submit();
      return;
    }
    if (el && el.click) el.click();
  }

  function askThenCheckout(el, text) {
    openBlankPop({ okLabel: "Continue", text: text || ACK_TEXT }).then(function (yes) {
      if (!yes) return;
      saveAck(true).then(function () { return restoreBlankLineAck(); }).then(function () {
        var host = el && el.closest ? el.closest(EXPRESS_SEL) : null;
        if (host) unshield(host);
        continueCheckout(el);
      }).catch(function () {});
    });
  }

  function productBlocked(el) {
    var form = productFormOf(el);
    if (!form || !form.querySelector || !form.querySelector("[data-ezink-blank-ack-prop]")) return false;
    if (productHasArtworkLocation(form) || productHasArtworkLocation(el)) return false;
    var kind = blankPurchaseKind(form);
    openBlankPop({ okLabel: "Add to cart", text: kind.text }).then(function (yes) {
      if (!yes) return;
      markProductAccepted(form, kind);
      var host = el && el.closest ? el.closest(EXPRESS_SEL) : null;
      if (host) unshield(host);
      resumeBuy(el);
    });
    return true;
  }

  // Cart attribute and line-property writes run one at a time.
  // A check that is still saving is queued ahead of a later clear, so it cannot
  // put the acknowledgment back after artwork removed it.
  var cartWrite = Promise.resolve();
  var writeDepth = 0;

  function enqueueCartWrite(job) {
    var run = cartWrite.then(function () {
      writeDepth += 1;
      return Promise.resolve().then(job).then(function (value) {
        writeDepth -= 1;
        return value;
      }, function (err) {
        writeDepth -= 1;
        throw err;
      });
    }, function () {
      writeDepth += 1;
      return Promise.resolve().then(job).then(function (value) {
        writeDepth -= 1;
        return value;
      }, function (err) {
        writeDepth -= 1;
        throw err;
      });
    });
    cartWrite = run.then(function () { return null; }, function () { return null; });
    return run;
  }

  function postCartAttribute(on) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ attributes: { "Blank acknowledgment": on ? ACK_TEXT : "" } })
    }).then(function (res) {
      if (!res.ok) throw new Error("Could not save the acknowledgment");
      return res.json();
    });
  }

  function saveAck(on) {
    return enqueueCartWrite(function () { return postCartAttribute(on); });
  }

  function pass(el) {
    if (!el || !el.setAttribute) return;
    el.setAttribute("data-ezink-pass", "1");
    var form = el.tagName === "FORM" ? el : formOf(el);
    if (form && form !== el) form.setAttribute("data-ezink-pass", "1");
  }

  function consumePass(el) {
    if (!el || !el.getAttribute || el.getAttribute("data-ezink-pass") !== "1") return false;
    el.removeAttribute("data-ezink-pass");
    return true;
  }

  function blockEvent(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
  }

  function isCheckoutHref(href) {
    if (!href) return false;
    try { href = new URL(href, window.location.origin).pathname; } catch (err) { return false; }
    return /\/checkout\/?$/.test(href) || /\/cart\/checkout\/?$/.test(href);
  }

  function checkoutControl(target) {
    if (!target || !target.closest) return null;
    var el = target.closest("button[name='checkout'], input[name='checkout'], .gpo-clone-checkout-button, shopify-accelerated-checkout-cart, .additional-checkout-buttons");
    if (el && el.closest(DRAWER_SEL + ", form.cart, [data-ezink-blank-ack-cart], .cart")) return el;
    var link = target.closest("a[href]");
    if (link && isCheckoutHref(link.getAttribute("href"))) return link;
    var express = target.closest("shopify-accelerated-checkout-cart, .additional-checkout-buttons");
    if (express && express.closest(DRAWER_SEL + ", form.cart, [data-ezink-blank-ack-cart]")) return express;
    return null;
  }

  function buyControl(target) {
    if (!target || !target.closest) return null;
    var add = target.closest("[data-add-to-cart], button[name='add'], input[name='add']");
    if (add) return add;
    var pay = target.closest(".shopify-payment-button, shopify-accelerated-checkout, .gpo-clone-atc-button");
    if (!pay) return null;
    if (pay.closest(DRAWER_SEL + ", [data-ezink-blank-ack-cart], form.cart")) return null;
    if (pay.closest("form[action*='/cart/add'], form.product-form, [data-product-form], .product-form")) return pay;
    return null;
  }

  function cartPageControl(el) {
    var form = el && el.closest && el.closest("[data-ezink-blank-ack-cart]");
    return form || null;
  }

  function continueCheckout(el) {
    pass(el);
    if (el && el.click) el.click();
  }

  function storedAttr() {
    var node = document.querySelector("[data-ezink-blank-attr]");
    if (!node) return "";
    try {
      var value = JSON.parse(node.textContent || "\"\"");
      return value ? String(value) : "";
    } catch (err) {
      return "";
    }
  }

  // direct posts from inside a queued cart job. Queuing that clear would wait
  // on the same job and never finish.
  function clearStoredAck(force, direct) {
    var node = document.querySelector("[data-ezink-blank-attr]");
    var current = storedAttr();
    if (node) node.textContent = "\"\"";
    if (!current && !force) return Promise.resolve();
    var post = direct ? postCartAttribute(false) : saveAck(false);
    return post.then(function () { return null; }, function () {
      if (node && current) node.textContent = JSON.stringify(current);
      return null;
    });
  }

  function editorDecorationState() {
    var keys = {};
    var sets = {};
    document.querySelectorAll("[data-ezink-line]").forEach(function (line) {
      if (!scopeHasDecoration(line)) return;
      var key = line.getAttribute("data-key") || "";
      var setId = line.getAttribute("data-art-set") || "";
      if (key) keys[key] = true;
      if (setId) sets[setId] = true;
    });
    return { keys: keys, sets: sets };
  }

  function editorSignature() {
    var editor = editorDecorationState();
    return Object.keys(editor.keys).sort().join(",") + "#" + Object.keys(editor.sets).sort().join(",");
  }

  function liveNeedsFromDom() {
    var rows = jsonRows();
    if (!rows) return null;
    return rowsNeedBlankAck(rows, editorDecorationState());
  }

  function noteEditorChange() {
    var sig = editorSignature();
    if (sig === editorSig) return;
    editorSig = sig;
    var live = liveNeedsFromDom();
    if (live === null) return;
    applyCartNeed(!!live);
    scheduleCartPull();
  }

  function handleCheckout(evt, el) {
    if (consumePass(el)) return;
    var pageForm = cartPageControl(el);
    var domNeeds = liveNeedsFromDom();
    if (pageForm && domNeeds === false) {
      if (storedAttr() || pulling || pullQueued) {
        blockEvent(evt);
        scheduleCartPull().then(function () { return clearStoredAck(true); }).then(function () { continueCheckout(el); });
      }
      return;
    }
    if (pageForm && domNeeds === true) {
      blockEvent(evt);
      askThenCheckout(el, checkoutPromptTextFromRows(jsonRows()));
      return;
    }
    if (domNeeds === null || !pageForm) {
      blockEvent(evt);
      fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          var editor = editorDecorationState();
          var prompt = false;
          if (items.length) {
            for (var n = 0; n < items.length; n++) {
              if (itemNeedsBlankPrompt(items[n], items) && !editorCoversItem(items[n], editor)) {
                prompt = true;
                break;
              }
            }
          } else {
            prompt = rowsNeedBlankAck(jsonRows() || [], editor);
          }
          if (!prompt) {
            if (cartAttribute(cart) || storedAttr() || pulling || pullQueued) {
              scheduleCartPull().then(function () { return clearStoredAck(true); }).then(function () { continueCheckout(el); });
            } else {
              continueCheckout(el);
            }
            return;
          }
          askThenCheckout(el, checkoutPromptText(items));
        })
        .catch(function () {
          askThenCheckout(el);
        });
      return;
    }
  }

  function blankPopClick(evt) {
    var target = evt.target;
    if (!target || !target.closest) return false;
    if (target.closest("[data-ezink-blank-pop-ok]")) {
      blockEvent(evt);
      closeBlankPop(true);
      return true;
    }
    if (target.closest("[data-ezink-blank-pop-cancel]")) {
      blockEvent(evt);
      closeBlankPop(false);
      return true;
    }
    return false;
  }

  // The product section registers its Add to cart listener during HTML parse,
  // before this deferred file. A window capture listener runs first and can
  // stop that add until the customer accepts the popup.
  window.addEventListener("click", function (evt) {
    if (blankPopClick(evt)) return;
    var target = evt.target;
    if (!target || !target.closest) return;
    var buy = buyControl(target);
    if (!buy) return;
    if (consumePass(buy)) return;
    if (productBlocked(buy)) blockEvent(evt);
  }, true);

  window.addEventListener("keydown", function (evt) {
    if (evt.key !== "Escape" && evt.key !== "Esc") return;
    var dlg = document.querySelector("[data-ezink-blank-pop]");
    if (!dlg || dlg.hidden) return;
    blockEvent(evt);
    closeBlankPop(false);
  }, true);

  document.addEventListener("click", function (evt) {
    if (blankPopClick(evt)) return;
    var target = evt.target;
    if (!target || !target.closest) return;
    if (target.closest(".ezink-blank-ack-shield")) return;
    var buy = buyControl(target);
    if (buy) {
      if (consumePass(buy)) return;
      if (productBlocked(buy)) blockEvent(evt);
      return;
    }
    var checkout = checkoutControl(target);
    if (!checkout) return;
    handleCheckout(evt, checkout);
  }, true);

  document.addEventListener("submit", function (evt) {
    var form = evt.target;
    if (!form || !form.getAttribute) return;
    if (consumePass(form)) return;
    var action = String(form.getAttribute("action") || form.action || "");
    if (form.hasAttribute("data-ezink-blank-ack-cart") || (action.indexOf("/cart") !== -1 && action.indexOf("/cart/add") === -1 && form.querySelector("[name='checkout']"))) {
      var button = form.querySelector("[name='checkout']") || form;
      handleCheckout(evt, button);
      return;
    }
    if (action.indexOf("/cart/add") === -1 && !form.hasAttribute("data-product-form")) return;
    if (productBlocked(form)) blockEvent(evt);
  }, true);

  document.addEventListener("change", function (evt) {
    var input = evt.target;
    if (!input || !input.hasAttribute || !input.hasAttribute("data-ezink-blank-ack-input")) return;
    var box = input.closest("[data-ezink-blank-ack]");
    if (!box) return;
    var checked = !!input.checked;
    if (box.getAttribute("data-ezink-blank-ack-context") === "cart") {
      cartBoxes().forEach(function (other) {
        var peer = other.querySelector("[data-ezink-blank-ack-input]");
        if (peer && peer !== input) peer.checked = checked;
      });
      if (checked) clearMessage(cartBoxes());
      var live = liveNeedsFromDom();
      setCartBoxes(live !== false);
      var attrNode = document.querySelector("[data-ezink-blank-attr]");
      if (checked) {
        if (attrNode) attrNode.textContent = JSON.stringify(ACK_TEXT);
        saveAck(true).then(function () { return restoreBlankLineAck(); }).catch(function () {
          input.checked = false;
          if (attrNode) attrNode.textContent = "\"\"";
          showMessage(box);
        });
      } else {
        clearStoredAck(true);
        forCartExpress(true);
      }
      return;
    }
    var form = formOf(box);
    if (!form) return;
    boxesIn(form).forEach(function (other) {
      if (other.getAttribute("data-ezink-blank-ack-context") === "cart") return;
      var peer = other.querySelector("[data-ezink-blank-ack-input]");
      if (peer && peer !== input) peer.checked = checked;
    });
    if (checked) clearMessage(boxesIn(form));
    syncProp(form);
    var visible = boxesIn(form).filter(ackBoxLive);
    syncExpress(form, visible.length > 0 && !checked);
  }, true);

  document.addEventListener("ezink-art-items-change", function (evt) {
    var root = evt.detail && evt.detail.root;
    var form = root && root.closest ? root.closest("form") : null;
    if (form) refreshProductForm(form);
    syncProductAck(root || null);
  });

  document.addEventListener("click", function (evt) {
    var target = evt.target;
    if (!target || !target.closest) return;
    if (!target.closest("[data-ezink-art-add], [data-ezink-art-remove]")) return;
    syncProductAck(target.closest("[data-ezink-art-pdp], [data-ezink-line]") || target);
  });

  document.addEventListener("change", function (evt) {
    var target = evt.target;
    if (!target || !target.matches) return;
    if (!target.matches("[data-ezink-promo-deco], [name='properties[Decoration type]'], [data-ezink-promo-method], [data-ezink-promo-loc], [data-ezink-file], [data-ezink-decoration], [data-ezink-art-loc], [data-ezink-art-transfer]")) return;
    var form = formOf(target);
    if (form) refreshProductForm(form);
    syncProductAck(target);
  }, true);

  var cartNeedState = null;
  var cartStamp = "";
  var editorSig = null;
  var pulling = false;
  var pullQueued = false;
  var pullPromise = Promise.resolve();

  function cartAttribute(cart) {
    var attrs = cart && cart.attributes;
    if (!attrs) return "";
    if (Array.isArray(attrs)) {
      for (var i = 0; i < attrs.length; i++) {
        var row = attrs[i];
        if (row && (row.name === ACK_KEY || row.key === ACK_KEY)) return String(row.value || "");
      }
      return "";
    }
    return String(attrs[ACK_KEY] || "");
  }

  function writeCartJson(items) {
    var node = document.querySelector("[data-ezink-blank-cart]");
    if (!node) return;
    var rows = (items || []).map(function (item) {
      return {
        key: item.key,
        set: String(propsOf(item)["_Artwork set"] || ""),
        needs: itemNeedsBlankPrompt(item, items)
      };
    });
    var text = JSON.stringify(rows);
    if (node.textContent !== text) node.textContent = text;
  }

  function uncheckCartBoxes() {
    cartBoxes().forEach(uncheckBox);
  }

  function placeDrawerBoxes() {
    document.querySelectorAll(DRAWER_SEL).forEach(function (drawer) {
      var near = drawer.querySelector("[name='checkout'], a[href*='/checkout'], .additional-checkout-buttons, shopify-accelerated-checkout-cart, .cart-popup__cta-link");
      if (near) ensureCartBox(near);
    });
  }

  function currentCartView() {
    var boxes = cartBoxes();
    return {
      show: boxes.some(function (box) { return !box.hidden; }),
      checked: anyChecked(boxes)
    };
  }

  function applyCartNeed(needs) {
    var view = cartAckView(currentCartView(), !!needs);
    if (view.show) {
      placeDrawerBoxes();
      if (view.checked) {
        cartBoxes().forEach(function (box) {
          var input = box.querySelector("[data-ezink-blank-ack-input]");
          if (input) input.checked = true;
        });
      } else {
        uncheckCartBoxes();
      }
      setCartBoxes(true);
      if (!view.checked) uncheckCartBoxes();
    } else {
      uncheckCartBoxes();
      setCartBoxes(false);
    }
    if (view.clearAttribute && writeDepth === 0) clearStoredAck(false);
    cartNeedState = !!needs;
  }

  function currentCartStamp() {
    var parts = [];
    document.querySelectorAll(DRAWER_SEL + ", [data-ezink-blank-ack-cart]").forEach(function (node) {
      var rows = node.querySelectorAll("[data-cart-item-key], [data-key], [data-ezink-line], .ajaxcart__product");
      var keys = [];
      Array.prototype.forEach.call(rows, function (row) {
        keys.push(row.getAttribute("data-cart-item-key") || row.getAttribute("data-key") || row.getAttribute("data-art-set") || "row");
      });
      parts.push(keys.join(","));
    });
    var count = document.querySelector("[data-cart-count]");
    parts.push("n" + (count ? String(count.textContent || "").replace(/\s+/g, "") : ""));
    return parts.join("|");
  }

  function restoreBlankLineAck() {
    if (typeof fetch !== "function") return Promise.resolve();
    return enqueueCartWrite(function () {
      return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var editor = editorDecorationState();
        var jobs = [];
        items.forEach(function (item) {
          if (!itemNeedsBlankAck(item, items) || editorCoversItem(item, editor)) return;
          var props = propsOf(item);
          var wanted = isCloseoutLine(item) ? CLOSEOUT_ACK_TEXT : ACK_TEXT;
          if (props[ACK_KEY] === wanted) return;
          if (!isCloseoutLine(item) && props[ACK_KEY] === CLOSEOUT_ACK_TEXT) return;
          var bag = replacementProperties(props);
          if (!bag) return;
          if (bag[ACK_KEY] === "") delete bag[ACK_KEY];
          bag[ACK_KEY] = wanted;
          if (isCloseoutLine(item)) bag[CLOSEOUT_KEY] = "1";
          jobs.push({
            id: item.key,
            quantity: parseInt(item.quantity, 10) || 1,
            properties: bag,
            fingerprint: itemFingerprint(item)
          });
        });
        var chain = Promise.resolve();
        jobs.forEach(function (job) {
          chain = chain.then(function () {
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              credentials: "same-origin",
              body: JSON.stringify({ id: job.id, quantity: job.quantity, properties: job.properties })
            }).then(function (res) {
              return res.json().then(function (body) {
                if (!res.ok || !body) return null;
                var matches = (body.items || []).filter(function (item) {
                  return itemFingerprint(item) === job.fingerprint && item.key !== job.id;
                });
                if (matches.length === 1) replaceLineKey(job.id, matches[0].key);
                return null;
              }, function () { return null; });
            }, function () { return null; });
          });
        });
        return chain;
      });
    });
  }

  function itemFingerprint(item) {
    var props = propsOf(item);
    var parts = [];
    Object.keys(props).sort().forEach(function (key) {
      if (key === ACK_KEY) return;
      var value = props[key];
      if (value == null || value === "") return;
      parts.push(key + "=" + (typeof value === "string" || typeof value === "number" ? String(value) : JSON.stringify(value)));
    });
    return String((item && (item.variant_id || item.id)) || "") + "|" + String((item && item.quantity) || "") + "|" + parts.join("&");
  }

  function replaceLineKey(oldKey, newKey) {
    if (!oldKey || !newKey || oldKey === newKey) return;
    var root = document.querySelector("[data-ezink-blank-ack-cart]") || document.body;
    var nodes = root.querySelectorAll ? [root].concat(Array.prototype.slice.call(root.querySelectorAll("*"))) : [root];
    nodes.forEach(function (el) {
      if (!el || !el.getAttribute) return;
      if (el.id && el.id.indexOf(oldKey) !== -1) el.id = el.id.split(oldKey).join(newKey);
      var attrs = el.attributes;
      if (!attrs) return;
      for (var i = 0; i < attrs.length; i++) {
        var value = attrs[i].value;
        if (value && value.indexOf(oldKey) !== -1) el.setAttribute(attrs[i].name, value.split(oldKey).join(newKey));
      }
    });
    var jsonNode = document.querySelector("[data-ezink-blank-cart]");
    if (jsonNode && jsonNode.textContent && jsonNode.textContent.indexOf(oldKey) !== -1) {
      jsonNode.textContent = jsonNode.textContent.split(oldKey).join(newKey);
    }
  }

  function pullCart(done) {
    if (typeof fetch !== "function") {
      if (done) done();
      return;
    }
    pulling = true;
    enqueueCartWrite(function () {
      return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var editor = editorDecorationState();
        var needs = itemsNeedAck(items, editor);
        writeCartJson(items);
        applyCartNeed(needs);
        var jobs = [];
        items.forEach(function (item) {
          var props = propsOf(item);
          if (!props[ACK_KEY]) return;
          if (itemNeedsBlankAck(item, items) && !editorCoversItem(item, editor)) return;
          var bag = replacementProperties(props);
          if (!bag) return;
          jobs.push({
            id: item.key,
            quantity: parseInt(item.quantity, 10) || 1,
            properties: bag,
            fingerprint: itemFingerprint(item)
          });
        });
        var chain = Promise.resolve();
        jobs.forEach(function (job) {
          chain = chain.then(function () {
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              credentials: "same-origin",
              body: JSON.stringify({ id: job.id, quantity: job.quantity, properties: job.properties })
            }).then(function (res) {
              return res.json().then(function (body) {
                if (!res.ok || !body) return null;
                var matches = (body.items || []).filter(function (item) {
                  return itemFingerprint(item) === job.fingerprint && item.key !== job.id;
                });
                if (matches.length === 1) replaceLineKey(job.id, matches[0].key);
                return null;
              }, function () { return null; });
            }, function () { return null; });
          });
        });
        if (!needs && cartAttribute(cart)) chain = chain.then(function () { return clearStoredAck(true, true); });
        return chain;
      })
      .catch(function () { return null; });
    }).then(function () {
      pulling = false;
      if (pullQueued) {
        pullQueued = false;
        pullCart(done);
        return;
      }
      if (done) done();
    });
  }

  function scheduleCartPull() {
    if (pulling || pullQueued) {
      pullQueued = true;
      return pullPromise;
    }
    pullQueued = true;
    pullPromise = new Promise(function (resolve) {
      setTimeout(function () {
        pullQueued = false;
        pullCart(resolve);
      }, 60);
    });
    return pullPromise;
  }

  function setProductBox(box, decorated) {
    if (!box) return;
    if (decorated) {
      uncheckBox(box);
      box.hidden = true;
      if (box.classList) box.classList.add("ezink-blank-ack--off");
      if (box.style && box.style.setProperty) box.style.setProperty("display", "none", "important");
      return;
    }
    var wasOff = box.classList && box.classList.contains("ezink-blank-ack--off");
    var wasHidden = !!box.hidden;
    if (box.classList) box.classList.remove("ezink-blank-ack--off");
    if (box.style && box.style.removeProperty) box.style.removeProperty("display");
    box.hidden = false;
    if (wasOff || wasHidden) uncheckBox(box);
  }

  function syncProductAck(hint) {
    var roots = [];
    if (hint) roots.push(hint);
    Array.prototype.forEach.call(document.querySelectorAll("[data-ezink-art-pdp]"), function (pdp) {
      if (roots.indexOf(pdp) < 0) roots.push(pdp);
    });
    var forms = [];
    roots.forEach(function (root) {
      var artRoot = root;
      if (root && root.closest) {
        var pdp = root.closest("[data-ezink-art-pdp]");
        if (pdp) artRoot = pdp;
      }
      var decorated = productHasArtworkLocation(artRoot);
      productAckBoxes(artRoot).forEach(function (box) {
        setProductBox(box, decorated);
        var form = formOf(box);
        if (form && forms.indexOf(form) < 0) forms.push(form);
      });
      var section = sectionNear(artRoot);
      if (section && section.querySelector) {
        var host = section.querySelector("form[data-product-form], form.product-form, form[action*='/cart/add']");
        if (host && forms.indexOf(host) < 0) forms.push(host);
      }
    });
    forms.forEach(syncProp);
    if (document.querySelector("[data-ezink-line]")) noteEditorChange();
  }
  api.syncProductAck = syncProductAck;

  function boot() {
    document.querySelectorAll("form[data-product-form], form.product-form, form[action*='/cart/add']").forEach(refreshProductForm);
    syncProductAck(null);
    var sig = editorSignature();
    var sigChanged = sig !== editorSig;
    editorSig = sig;
    var stamp = currentCartStamp();
    var stampChanged = stamp !== cartStamp;
    cartStamp = stamp;
    var live = liveNeedsFromDom();
    if (cartNeedState === null) {
      if (live === true) {
        placeDrawerBoxes();
        setCartBoxes(true);
      } else if (live === false) setCartBoxes(false);
    } else if (live !== null && !!live !== !!cartNeedState) {
      applyCartNeed(live);
    }
    if (cartNeedState === null || stampChanged || sigChanged) scheduleCartPull();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  if (window.MutationObserver) {
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        boot();
      }, 80);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
